(ns app.front.ui.grouped-menu
  (:require [app.front.ui.dropdown :as ui-dd]
            [app.front.util :as futil]
            [core.front.carbon :as cc]))

(defn- group-section [{:keys [title options empty-text]}]
  [:div.flex.flex-col.py-1
   [:span.font-bold.text-xs.text-gray-500.px-2.py-1 title]
   (if (seq options)
     (futil/for-frag [{:keys [label on-click]} options]
       (cc/button {:kind       :ghost
                   :size       :small
                   :class-name "justify-start normal-case w-full text-left"
                   :on-click   on-click}
                  label))
     (when empty-text
       [:span.text-xs.text-gray-400.px-2.py-1 empty-text]))])

(defn grouped-menu [{:keys [toggle-element sections align toggle-props options-props]
                     :or   {align "left"}}]
  [ui-dd/dropdown
   {:align         align
    :toggle-props  (merge {:omit-icon? true :button? true} toggle-props)
    :options-props (merge {:class "bg-ui-white w-max filter drop-shadow-xl max-h-72 border border-solid border-gray-300 rounded"}
                          options-props)}
   toggle-element
   (into [:div.flex.flex-col.divide-y.divide-gray-200.p-1]
         (map group-section sections))])
